import EventTagLayout from './EventTagLayout';

export default EventTagLayout;
